import { handleActions } from 'redux-actions'
import { IMessage } from '../types/message'
import { SET_MESSAGE } from './messagesActions'

export interface IMessagesState {
  message: IMessage | null
}

const initialState: IMessagesState = {
  message: null,
}

export default handleActions<IMessagesState, IMessage | null>(
  {
    [SET_MESSAGE]: (state, { payload }) => ({
      ...state,
      message: payload,
    }),
  },
  initialState,
)
